import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SearchPaginatorComponent } from './search-paginator.component'
import { SharedModule } from '../shared/shared.module'
import { NumbersPaginatorComponent } from './numbers-paginator/numbers-paginator.component'
import { GoToPaginatorComponent } from './go-to-paginator/go-to-paginator.component'
import { ReactiveFormsModule } from '@angular/forms'
import { SeeMorePaginatorComponent } from './see-more-paginator/see-more-paginator.component'



@NgModule({
  declarations: [SearchPaginatorComponent, NumbersPaginatorComponent, GoToPaginatorComponent, SeeMorePaginatorComponent],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
  ],
  exports: [SearchPaginatorComponent]
})
export class SearchPaginatorModule { }
